import {
  Block,
  Button,
  FlexContainer,
  InputCheckbox,
  Loader,
  Modal,
  Span,
  TriangleAlertIcon,
} from '@uni-space/uni-components';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getScalesWeight } from '../api';
import { getUseScalesWeight, setUseScalesWeight } from '../model/scalesSettings';

export interface BagsSettingsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function BagsSettingsModal({ isOpen, onClose }: BagsSettingsModalProps) {
  const { t } = useTranslation();
  const [isChecking, setIsChecking] = useState<boolean>(false);
  const [isScalesConnected, setIsScalesConnected] = useState<boolean>(false);
  const [useScales, setUseScales] = useState<boolean>(getUseScalesWeight);

  const checkScalesConnection = async () => {
    setIsChecking(true);
    const res = await getScalesWeight();
    setIsScalesConnected(Boolean(res));
    setIsChecking(false);
  };

  useEffect(() => {
    if (!isOpen) return;
    setUseScales(getUseScalesWeight());
    checkScalesConnection();
  }, [isOpen]);

  const handleToggle = (checked: boolean) => {
    // Включить можно только при работающем подключении к весам; выключить — всегда.
    if (checked && !isScalesConnected) return;
    setUseScales(checked);
    setUseScalesWeight(checked);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <FlexContainer direction="column" gap="16px" style={{ maxWidth: '440px' }}>
        <Block textAlign="center">
          <Span fs={24}>{t('bagsSettings.title')}</Span>
        </Block>
        <FlexContainer direction="column" gap="6px">
          <InputCheckbox
            id="use-scales-weight-toggle"
            checked={useScales}
            disabled={isChecking || (!isScalesConnected && !useScales)}
            label={t('bagsSettings.useScalesWeight')}
            onChange={handleToggle}
          />
          <Span fs={13}>{t('bagsSettings.useScalesWeightDesc')}</Span>
        </FlexContainer>
        {isChecking ? (
          <FlexContainer gap="8px" align="center">
            <Loader size="s" />
            <Span fs={14}>{t('tryConnectToScales')}</Span>
          </FlexContainer>
        ) : (
          !isScalesConnected && (
            <FlexContainer gap="8px" align="center">
              <TriangleAlertIcon color="#EF6D7C" size="s" />
              <Span fs={14} color="#EF6D7C">
                {t('bagsSettings.scalesNotConnectedHint')}
              </Span>
            </FlexContainer>
          )
        )}
        {!isChecking && !isScalesConnected && (
          <Button size="s" type="secondary" onClick={checkScalesConnection}>
            {t('bagsSettings.checkConnection')}
          </Button>
        )}
        <Button onClick={onClose}>{t('understood')}</Button>
      </FlexContainer>
    </Modal>
  );
}
